import { Palette } from './types';

export const CHART_LABEL_CLASSNAME = 'chartLabel';
export const CHART_CONTENT_CLASSNAME = 'chartContent';
export const CHOROPLETH_LEGEND_CLASSNAME = 'choroplethLegend';
export const CHART_LEGEND_CLASSNAME = 'chartLegend';
export const MAX_CHART_LABEL_LENGTH = 24;
export const DEFAULT_PALETTE: Palette = {
    background: 'transparent',
    text: '#757575',
    grid: '#ddd',
    axes: '#757575',
    marks: {
        default: '#122945',
        blur: '#e9edf2',
        hover: '#f8d6d5',
        active: [
            '#122945',
            '#f75151',
            '#3bbc97',
            '#a0b9d0',
            '#D8C092',
            '#3B83EF',
            '#F77702',
            '#B2EDD9',
            '#EF73A0',
            '#225B7B',
            '#138E57',
            '#FFD266'
        ],
    },
};
